import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import 'dayjs/locale/zh-cn'

export interface LocaleConfig {
  dayjs: string
}

export const isChinese = (language: string): boolean => {
  return language
    .toLowerCase()
    .startsWith('zh')
}

export const getLocaleConfig = (language: string): LocaleConfig => {
  return isChinese(language) ? { dayjs: 'zh-cn' } : { dayjs: 'en' }
}

export const useLocale = () => {
  const { i18n } = useTranslation()
  const [locale, setLocale] = useState(() => getLocaleConfig(i18n.language))

  useEffect(
    () => {
      const handleLanguageChange = (lng: string) => {
        const config = getLocaleConfig(lng)
        setLocale(config)
        dayjs.locale(config.dayjs)
      }

      // 设置初始 dayjs locale。
      dayjs.locale(locale.dayjs)

      // 监听语言变更。
      i18n.on('languageChanged', handleLanguageChange)

      return () => {
        i18n.off('languageChanged', handleLanguageChange)
      }
    },
    [i18n, locale.dayjs],
  )

  return {
    locale,
  }
}
